export enum HTTP_METHODS {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE'
}

export enum HTTP_STATUS_CODE {
  MOVED_PERMANENTLY = 301,
  FOUND = 302,
  TEMPORARY_REDIRECT = 307,
  PERMANENT_REDIRECT = 308,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404
}

export enum HTTP_HEADER_KEYS {
  X_ACCESS_TOKEN = 'x-access-token',
  AUTHORIZATION = 'authorization',
  ESK = 'esk',
  DEVICE_ID = 'device_id',
  ACCEPT = 'Accept',
  CONTENT_TYPE = 'Content-Type',
  X_Z5_GUEST_TOKEN = 'x-z5-guest-token',
  X_USER_TYPE = 'x-user-type',
  X_Z5_APP_VERSION = 'x-z5-appversion',
  X_Z5_APP_PLATFORM = 'x-z5-appplatform'
}
export enum HTTP_HEADER_VALUES {
  APPLICATION_JSON = 'application/json',
  APPLICATION_FORM_URL_ENCODED = 'application/x-www-form-urlencoded'
}

export enum HTTP_URL_PARAMS {
  DISPLAY_LANGUAGE = 'translation',
  CONTENT_LANGUAGE = 'languages',
  COUNTRY_CODE = 'country'
}
